import clsx from 'clsx';

import { useLocalize } from '../../hooks';
import type { CompleteQuizResult } from '../../api';

type QuizResultStatusProps = {
  big?: boolean;
  result?: CompleteQuizResult;
};

export const QuizResultStatus: React.FC<QuizResultStatusProps> = ({
  big,
  result,
}) => {
  const { t } = useLocalize();
  if (!result) return;

  const { passed, correctAnswers = 0, totalQuestions = 1 } = result;

  const status = passed ? t('course.page.passed') : t('course.page.notpassed');
  const resultStr = `${correctAnswers}/${totalQuestions || 1}`;

  return (
    <div className={clsx('flex flex-col', big ? 'items-center' : '')}>
      <span
        className={clsx(
          'mb-tiny text-subTitle',
          big ? 'text-small' : 'text-tiny'
        )}
      >
        {t('course.page.result')}:
      </span>
      <span
        className={clsx('mb-xs font-bold', big ? 'text-big' : 'text-medium')}
      >
        {t('course.page.correct')} {resultStr}
      </span>
      <span
        className={clsx(
          passed
            ? 'bg-correctBack text-completed'
            : 'bg-strongWarning text-nonCorrect',
          'text-center font-semibold rounded-card',
          big ? 'px-md py-sm' : 'px-sm py-xs',
          big ? 'text-small' : 'text-tiny'
        )}
      >
        {status}
      </span>
    </div>
  );
};
